import { useContext, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import * as Joi from "joi-browser";
import { Modal } from "react-bootstrap";
import { PhoneInput } from 'react-international-phone';
import LandLordContext from "../../../context/landlord/LandLordContext";
import { haveValue } from "../../../helper/common";
import Cancelimg from "../../../assets/img/cancel-01.svg";

const AddSubLLModal = (props) => {
  const landLordContext = useContext(LandLordContext);
  const { addSubLL } = landLordContext;
  const { showAddSubLL, handleCloseModal } = props;
  const { _t } = useTranslator();
  const schema = {
    fname_companyName: Joi.string().min(1).required().label("First name"),
    lname: Joi.string().min(1).required().label("Last name"),
    phone: Joi.string().allow("", null).label("Phone"),
    email: Joi.string().email().required().label("Email"),
    isAdmin: Joi.boolean(),
  };
  const [phoneNumber, setPhoneNumber] = useState("");
  const [landlordProfile, setLandlordProfile] = useState({
    fname_companyName: "",
    lname: "",
    phone: "",
    email: "",
    isAdmin: false,
  });
  const [errors, setErrors] = useState({});

  const getErrorMessage = (field, message) => {
    switch (field) {
      case "fname_companyName":
        return _t("firstNameOrCompanyNameIsRequired");
      case "lname":
        return _t("lastNameIsRequired");
      case "phone":
        return _t("phoneIsRequired");
      case "email":
        return message === "string.email"
          ? _t("pleaseEnterValidEmail")
          : _t("emailIsRequired");
      default:
        return message;
    }
  };

  const changeLandlordPhoneNumber = (value) => {
    const phone = value?.replace("+", "") || "";
    setPhoneNumber(phone);
    setLandlordProfile((prev) => ({ ...prev, phone }));
    const { phone: _, ...updatedState } = errors; // Destructure and remove the key
    setErrors(updatedState);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const { [name]: _, ...updatedState } = errors; // Destructure and remove the key
    setErrors(updatedState);
    setLandlordProfile((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const { error } = Joi.validate(landlordProfile, schema, {
      abortEarly: false,
    });
    if (error) {
      const newErrors = error.details.reduce((acc, curr) => {
        acc[curr.path[0]] = getErrorMessage(curr.path[0], curr.type);
        return acc;
      }, {});
      setErrors(newErrors);
      return false;
    }
    setErrors({});
    return true;
  };

  const handleAddSubLL = () => {
    if (validateForm()) {
      addSubLL(landlordProfile)
        .then((res) => {
          if (haveValue(res)) {
            handleCloseModal();
          }
        })
        .catch((err) => {
          console.log("Error inside handleAddSubLL");
        });
    }
  };
  return (
    <>
      <Modal
        show={showAddSubLL}
        onHide={handleCloseModal}
        centered
        className="newmodalui wrapper-modal asguarantor modal-xl add-landlord-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <h4 className="modal-title-text">{_t("addSubLandlord")}</h4>
          </Modal.Title>
          <div className="cursor-pointer" onClick={handleCloseModal}>
            <img
              src={Cancelimg}
              alt="icon"
              className="canceicon topRightIcon"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <div className="forminput customInput">
                <label className="forminput label-text">
                  <h6 className="modal-label">{_t("firstName")}</h6>
                </label>
                <input
                  type="text"
                  name="fname_companyName"
                  onChange={handleInputChange}
                  className="form-control modal-input"
                  placeholder={_t("enterFirstName")}
                />
                {errors.fname_companyName && <p>{errors.fname_companyName}</p>}
              </div>
            </div>

            <div className="col-md-6">
              <div className="forminput customInput">
                <label className="forminput label-text">
                  <h6 className="modal-label">{_t("lastName")}</h6>
                </label>
                <input
                  type="text"
                  name="lname"
                  onChange={handleInputChange}
                  className="form-control modal-input"
                  placeholder={_t("enterLastName")}
                />
                {errors.lname && <p>{errors.lname}</p>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="forminput customInput">
                <label className="forminput label-text">
                  <h6 className="modal-label">{_t("email")}</h6>
                </label>
                <input
                  type="email"
                  name="email"
                  onChange={handleInputChange}
                  className="form-control modal-input"
                  placeholder={_t("enterEmail")}
                />
                {errors.email && <p>{errors.email}</p>}
              </div>
            </div>
            <div className="col-md-6">
              <div className="forminput customInput">
                <h6 className="modal-label mb-0">{_t("phoneNumber")}</h6>
                <PhoneInput
                  className="phone_input_info"
                  international
                  defaultCountry={"es"}
                  value={phoneNumber}
                  onChange={changeLandlordPhoneNumber}
                  placeholder={_t("enterPhoneNumber")}
                />
                {errors.phone && <p>{errors.phone}</p>}
              </div>
            </div>
            <div className="checkboxWrapper">
              <label className="custom-gap-3 custom-checkbox">
                <input
                  type="checkbox"
                  name="isAdmin"
                  onChange={(e) =>
                    setLandlordProfile((prevData) => ({
                      ...prevData,
                      isAdmin: !prevData.isAdmin,
                    }))
                  }
                  checked={landlordProfile?.isAdmin}
                /><span className="custom-checkmark"></span>
                {_t(
                  "addAsAdminLL",
                  "When adding a Sub LL to an agency to ask if this is a admin or not."
                )}
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="addGuarantorButton modal-btn"
            onClick={handleAddSubLL}
          >
            {_t("submit")}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddSubLLModal;
